import { buildUseRecoilValue } from "../../common/miscellaneous/buildUseRecoilValue";
import { orderErrorEventAtom } from "../miscellaneous/orderErrorEventAtom";

export const useOrderErrorEventValue = buildUseRecoilValue(orderErrorEventAtom);
